import { Tabs } from "antd";
import RestoreDbtable from "./RestoreDbTable";
import { RestoreDbTypes } from "../../enums/RestoreDatabaseEnums";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import JobDatabaseService from "../../services/jobDatabase.service";

const { TabPane } = Tabs;

const tabItems = [
  {
    key: RestoreDbTypes.CUSTOMER,
    title: "Customer Database",
  },
  {
    key: RestoreDbTypes.OWNER_OPERATOR,
    title: "Owner Operator Database",
  },
  {
    key: RestoreDbTypes.CDL_DRIVER,
    title: "CDL Driver Database",
  },
  {
    key: RestoreDbTypes.QUARRY,
    title: "Quarry Database",
  },
  { key: RestoreDbTypes.JOB, title: "Job Database" },
];

const RestoreDatabase = () => {
  const location = useLocation();
  const getActiveKeyFromHash = () => {
    const hash = location.hash.replace("#", "");
    const isValidKey = tabItems.some((tab) => tab.key === hash);
    return isValidKey ? (hash as RestoreDbTypes) : RestoreDbTypes.CUSTOMER;
  };

  const { GetPaginationDefaultMeta } = JobDatabaseService();
  const [activeView, setActiveView] =
    useState<RestoreDbTypes>(getActiveKeyFromHash);
  window.location.hash = activeView;

  const { data: defaultData, isFetching: gettingDefaults } =
    GetPaginationDefaultMeta();

  useEffect(() => {
    setActiveView(getActiveKeyFromHash());
  }, [location.hash]);

  const handleTabChange = (key: RestoreDbTypes) => {
    setActiveView(key);
    window.location.hash = key;
  };

  return (
    <>
      <Tabs
        activeKey={activeView}
        type="line"
        tabPosition="top"
        onChange={handleTabChange}
      >
        {tabItems.map((tab) => (
          <TabPane tab={tab.title} key={tab.key} />
        ))}
      </Tabs>
      <RestoreDbtable
        activeDBView={activeView}
        defaultPagination={defaultData}
        gettingDefaults={gettingDefaults}
      />
    </>
  );
};

export default RestoreDatabase;
